import React, { useEffect, useRef } from 'react'
import cardData from '../../assets/cards/Cards_data';
import './TitleCards.css';
function TitleCards({title}) {
    const cards = useRef()
    const handleWheel=(event)=>{
        event.preventDefault();
        cards.current.scrollLeft += event.deltaY;
    }
    
    useEffect(()=>{
        cards.current.addEventListener("wheel",handleWheel)
    },[])
  return (
    <div className='container py-4'>
        <h2 className='movies_type'>{title?title:"Popualar on Netflix"}</h2>
        <div className='cards' ref={cards}>
        {
            cardData.map((data,index)=>{
                return(
                    <div key={index}>
                        <div>
                            <img className='card_img' src={data.image} alt=''/>
                        </div>
                        <p className='card_name'>{data.name}</p>
                    </div>
                )
            })
        }
        </div>
    </div>
  )
}

export default TitleCards